import React from "react";
import { Link } from "gatsby";
import { css } from "@emotion/react";

import { devices, colors } from "../assets/styles/variables";
import iconArrowPrev from "../assets/icons/icon_arrow_prev.svg";
import iconArrowNext from "../assets/icons/icon_arrow_next.svg";

const volumeNav = css`
  display: flex;
  max-width: 600px;
  margin: 20px auto 0;

  &.one-nav {
    justify-content: center;
    > li {
      @media screen and (min-width: ${devices.desktop}) {
        width: 50%;
      }
    }
  }

  > li {
    display: flex;
    align-items: center;
    max-width: 300px;
    width: 100%;
  }

  .link {
    display: flex;
    width: 100%;
    height: 100%;
    text-decoration: none;
    background-color: ${colors.white};
    overflow: hidden;

    &.prev {
      flex-direction: row-reverse;
      margin-left: 2px;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }

    &.next {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
  }

  .icon {
    display: flex;
    align-items: center;
    padding: 0 5px;
    background-color: ${colors.red};

    @media screen and (min-width: ${devices.mobile}) {
      padding: 0 11px;
    }
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 14px 10px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    color: ${colors.black};

    @media screen and (min-width: ${devices.mobile}) {
      padding: 22px 10px;
      font-size: 18px;
    }
  }
`;

interface Props {
  slug: string;
  anotherEpisodeBackward?: string;
  anotherEpisodeForward?: string;
}

const VolumeNav = (props: Props) => {
  const { slug, anotherEpisodeBackward, anotherEpisodeForward } = props;
  const hasOneNav =
    (anotherEpisodeBackward && !anotherEpisodeForward) ||
    (!anotherEpisodeBackward && anotherEpisodeForward);

  const renderNav = (episodeSlug: string, title: string, isPrev: boolean) => (
    <li>
      <Link className={`link ${isPrev ? "prev" : "next"}`} to={`/${slug}/${episodeSlug}`}>
        <div className="icon">
          <img
            src={isPrev ? iconArrowPrev : iconArrowNext}
            width="14"
            height="16"
            alt=""
          />
        </div>
        <div className="title">{title}</div>
      </Link>
    </li>
  );

  return (
    <ul css={volumeNav} className={`${hasOneNav && "one-nav"}`}>
      {anotherEpisodeForward &&
        renderNav(anotherEpisodeForward, "次のエピソード", false)}
      {anotherEpisodeBackward &&
        renderNav(anotherEpisodeBackward, "前のエピソード", true)}
    </ul>
  );
};

export default VolumeNav;
